export const M_TRACK_LOGO = '../images/vm/m-track/mtrack-lockup.png';
export const M_TRACK_LOGO_LIME =
  '../images/vm/m-track/logos/m-track-logo-lime.svg';
export const M_TRACK_CONSENTED_TEXT =
  'All your business, all in one place. Get the big picture at a glance, and connect market-leading business tools to dig deeper and plan ahead.';
export const M_TRACK_SIGNUP_TEXT =
  'Get the bigger picture. Link up your business to market-leading tools for free, to track them from one simple dashboard.';
export const M_TRACK_CONSENTED_CTA = 'View my dashboard';
export const M_TRACK_SIGNUP_CTA = 'Get started';
export const REQUEST_M_TRACK_WHITELIST = 'REQUEST_M_TRACK_WHITELIST';
export const REQUEST_M_TRACK_WHITELIST_SUCCESS =
  'REQUEST_M_TRACK_WHITELIST_SUCCESS';
export const REQUEST_M_TRACK_WHITELIST_ERROR =
  'REQUEST_M_TRACK_WHITELIST_ERROR';
export const REQUEST_M_TRACK_CONSENT = 'REQUEST_M_TRACK_CONSENT';
export const REQUEST_M_TRACK_CONSENT_SUCCESS =
  'REQUEST_M_TRACK_CONSENT_SUCCESS';
export const REQUEST_M_TRACK_CONSENT_ERROR = 'REQUEST_M_TRACK_CONSENT_ERROR';
export const REQUEST_CREATE_M_TRACK_CONSENT = 'REQUEST_CREATE_M_TRACK_CONSENT';
export const REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS =
  'REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS';
export const REQUEST_CREATE_M_TRACK_CONSENT_ERROR =
  'REQUEST_CREATE_M_TRACK_CONSENT_ERROR';
